var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    viewBox: "0 0 34 34",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st3{fill:none;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16.8643341,
    cy: 11.6471491,
    r: 5.6451435
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16.862278,
    x2: 16.862278,
    y1: 17.2903118,
    y2: 21.0006008
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "24.6870995,24.001955 24.6870995,21.0006008 9.312335,21.0006008 9.312335,24.001955  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8663902,11.6451559V9.5906868V11.6451559z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.0102825,
    x2: 16.8663902,
    y1: 13.0843277,
    y2: 11.6451559
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.5276699,26.1599255C26.5276699,27.1732178,25.7008152,28,24.6876659,28   c-1.0131512,0-1.840004-0.8267822-1.840004-1.8400745c0-1.0246658,0.8268528-1.8514481,1.840004-1.8514481   C25.7008152,24.3084774,26.5276699,25.1352596,26.5276699,26.1599255z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.152339,26.1599255C11.152339,27.1732178,10.3254852,28,9.312335,28   s-1.8400044-0.8267822-1.8400044-1.8400745c0-1.0246658,0.8268542-1.8514481,1.8400044-1.8514481   S11.152339,25.1352596,11.152339,26.1599255z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit);
export default __webpack_public_path__ + "static/media/unit.6051dee135d05fd887a45150cb2b297d.svg";
export { ForwardRef as ReactComponent };